(function() {
    'use strict';
    //Angular module for IBCOSE view, this is the app entry point 
    angular.module('ib-check-in-search', []);
})();